import React, { useContext, useEffect, useState, useMemo } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Card, Modal, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import JoditEditor from 'jodit-react';
import './managebrodcast.css';
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import { t } from "i18next";

export default function BroadcastViewPage() {
    const [content, setContent] = useState(0);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [AllTitleerror, setAllTitleerror] = useState('');
    const [Msgerror, setMsgerror] = useState('');
    const [selecterror, setselecterror] = useState('');
    const [selecttitleerror, setselecttitleerror] = useState('');
    const [selectMsgerror, setselectMsgerror] = useState('');

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [broadcastModalType, setBroadcastModalType] = useState('success');
    const [broadcastErrorMsg, setBroadcastErrorMsg] = useState('');

    const contentTypes = {
        all: 0,
        specific: 1
    };

    useEffect(() => {
        const user_type = localStorage.getItem('user_type');
        axios
            .post(API_URL + '/get_manage_users', { user_type })
            .then((response) => {
                const userOptions = response.data.user_arr.map((user) => ({
                    value: user.user_id,
                    label: user.name
                }));
                setUsers(userOptions);
            })
            .catch((error) => {
                console.error('There was an error fetching the users!', error);
            });
    }, []);

    const handleButtonClick = (contentType) => {
        setContent(contentTypes[contentType]);
    };

    const SendBroadcast = () => {
        let hasError = false;

        // Validate inputs based on content type
        if (content === contentTypes.all) {
            if (!title.trim()) {
                setAllTitleerror(t("enter_title"));
                hasError = true;
            } else {
                setAllTitleerror('');
            }
            if (!message.trim()) {
                setMsgerror(t("enter_message"));
                hasError = true;
            } else {
                setMsgerror('');
            }
        } else if (content === contentTypes.specific) {
            if (!title.trim()) {
                setselecttitleerror(t("enter_title"));
                hasError = true;
            } else {
                setselecttitleerror('');
            }
            if (!message.trim()) {
                setselectMsgerror(t("enter_message"));
                hasError = true;
            } else {
                setselectMsgerror('');
            }
            if (selectedUsers.length === 0) {
                setselecterror(t("selected_user"));
                hasError = true;
            } else {
                setselecterror('');
            }
        }

        // If there are any errors, do not proceed
        if (hasError) {
            return;
        }

        const data = {
            action: 'send',
            subject: title,
            message: message,
            select_arr: content === contentTypes.specific ? JSON.stringify(selectedUsers.map(user => user.value)) : [],
            userType: content === contentTypes.all ? 'all' : 'user'
        };
        console.log('data', data);

        setIsButtonDisabled(true);
        axios
            .post(API_URL + '/send_notification', data)
            .then((res) => {
                console.log(res);
                setTitle('');
                setMessage('');
                setSelectedUsers([]);
                setBroadcastModalType('success');
                setShowModal(true);
                setTimeout(() => {
                    handleModalClose();
                }, 1000);
            })
            .catch((err) => {
                setBroadcastModalType('error');
                setBroadcastErrorMsg(err?.response?.data?.message || err?.message || t('broadcast_send_failed'));
                setShowModal(true);
                setTimeout(() => {
                    handleModalClose();
                }, 3000);
            });

    };

    const handleModalClose = () => {
        setShowModal(false);
        setIsButtonDisabled(false);
        setBroadcastModalType('success');
        setBroadcastErrorMsg('');
    };

    return (
        <PageLayout>
            <Row>


                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('broadcast_details')}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/dashboard'}`} className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item">
                                    <Link to='#' className="mc-breadcrumb-link">{t('broadcast')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">{t('broadcast_list')}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Card.Body className="mt-5">
                    <Form>
                        <nav className="navbar navbar-expand-lg navbar-light navBar">
                            <div
                                className="container mobile"
                                id="container-div"
                                style={{ marginTop: '-2rem', width: '22rem', borderRadius: '5px', marginLeft: '2.3rem' }}
                            >
                                <button
                                    className={`btn btn-outline-success me-2 mb-2 btn-content ${content === contentTypes.all ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('all')}
                                >
                                    {t('all_user')}
                                </button>
                                <button
                                    className={`btn btn-outline-success me-2  mb-2 btn-content ${content === contentTypes.specific ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('specific')}
                                >
                                    {t('selected_user')}
                                </button>
                            </div>
                        </nav>

                        {content === 0 && (
                            <div style={{ margin: '3rem' }}>
                                <div>
                                    <Form.Group className="mb-3" as={Row} controlId="formHorizontalEmail">
                                        <Form.Label>  {t('title')}</Form.Label>
                                        <Col sm={7}>
                                            <Form.Control
                                                type="text"
                                                placeholder={t('enter_title')}
                                                value={title}
                                                onChange={(e) => {
                                                    setTitle(e.target.value);
                                                    setAllTitleerror('');
                                                }}
                                            />
                                            {AllTitleerror && <span className="text-danger">{AllTitleerror}</span>}
                                        </Col>
                                    </Form.Group>

                                    <Form.Group className="mb-3" as={Row} controlId="formHorizontalMessage">
                                        <Form.Label>  {t('message')}</Form.Label>
                                        <Col sm={7}>
                                            <Form.Control
                                                as="textarea"
                                                placeholder={t('enter_message')}
                                                rows={3}
                                                value={message}
                                                onChange={(e) => {
                                                    setMessage(e.target.value);
                                                    setMsgerror('');
                                                }}
                                            />
                                            {Msgerror && <span className="text-danger">{Msgerror}</span>}
                                        </Col>
                                    </Form.Group>

                                    <Form.Group className="mb-3 form" as={Row}>
                                        <Col sm={{ span: 10 }}>
                                            <Button style={{ width: '15rem', marginLeft: '10px' }} className="send-btn" onClick={SendBroadcast} disabled={isButtonDisabled}>
                                                {t('send')}
                                            </Button>
                                        </Col>
                                    </Form.Group>
                                </div>
                            </div>
                        )}

                        {content === 1 && (
                            <div style={{ margin: '3rem' }}>
                                <div>
                                    <Form.Group className="mb-3" as={Row} controlId="formHorizontalSelect">
                                        <Form.Label>  {t('selected_user')}</Form.Label>
                                        <Col sm={7}>
                                            <Select
                                                isMulti
                                                options={users}
                                                value={selectedUsers}
                                                onChange={(e) => {
                                                    setSelectedUsers(e);
                                                    setselecterror('');
                                                }}
                                                placeholder={t("selected_user")}
                                            />
                                            {selecterror && <span className="text-danger">{selecterror}</span>}
                                        </Col>
                                    </Form.Group>

                                    <Form.Group className="mb-3" as={Row} controlId="formHorizontalEmail">
                                        <Form.Label>  {t('title')}</Form.Label>
                                        <Col sm={7}>
                                            <Form.Control
                                                type="text"
                                                placeholder={t('enter_title')}
                                                value={title}
                                                onChange={(e) => {
                                                    setTitle(e.target.value);
                                                    setselecttitleerror('');
                                                }}
                                            />
                                            {selecttitleerror && <span className="text-danger">{selecttitleerror}</span>}
                                        </Col>
                                    </Form.Group>

                                    <Form.Group className="mb-3" as={Row} controlId="formHorizontalMessage">
                                        <Form.Label>  {t('message')}</Form.Label>
                                        <Col sm={7}>
                                            <Form.Control
                                                as="textarea"
                                                placeholder={t('enter_message')}
                                                rows={3}
                                                value={message}
                                                onChange={(e) => {
                                                    setMessage(e.target.value);
                                                    setselectMsgerror('');
                                                }}
                                            />
                                            {selectMsgerror && <span className="text-danger">{selectMsgerror}</span>}
                                        </Col>
                                    </Form.Group>

                                    <Form.Group className="mb-3 form" as={Row}>
                                        <Col sm={{ span: 10 }}>
                                            <Button style={{ width: '15rem', marginLeft: '10px' }} className="send-btn" onClick={SendBroadcast}
                                                disabled={isButtonDisabled}>
                                                {t('send')}
                                            </Button>
                                        </Col>
                                    </Form.Group>
                                </div>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Row>

            {/* For notify after Broadcast sent or error */}
            <Modal show={showModal} onHide={() => { setShowModal(false); setIsButtonDisabled(false) }}>
                <Modal.Header>
                    <Modal.Title>{broadcastModalType === 'success' ? t("broadcast_sent") : t("error")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{broadcastModalType === 'success' ? t("broadcast_sent_succ") : broadcastErrorMsg}</p>
                </Modal.Body>
                <Modal.Footer />
            </Modal>
        </PageLayout>
    );
}
